import { Title } from '#app/interface/cabinet/header/Dropdown/styles';
import Dropdown from '#app/interface/cabinet/header/Dropdown/Dropdown';
import React from 'react';
import { isManager } from '#app/helpers/isManager';
import { routes } from '#app/constants/routes';

const AccountingDropdown = ({ i18n, data, handleMenu, url }) => {
  const condition1 = routes.accountingValidPaths.includes(url);

  const menuLinks = [
    { id: 'accounting-menu-5', link: routes.accounting.dashboard, text: i18n.menu.dashboard },
    { id: 'accounting-menu-7', link: routes.accounting.values, text: i18n.menu.values },
    { id: 'accounting-menu-6', link: routes.accounting.dynamic, text: i18n.menu.dynamic },
    {
      id: 'accounting-menu-1',
      link: routes.accounting.accountsPropertiesObligations,
      text: i18n.menu.accounts,
    },
    { id: 'accounting-menu-4', link: routes.accounting.logs, text: i18n.menu.operations },
  ];

  if (isManager(data)) {
    menuLinks.push({
      id: 'accounting-menu-5',
      link: routes.accounting.clients,
      text: i18n.menu.clients,
    });
  }

  return (
    <Dropdown
      id="dropdown-accounting"
      width="auto"
      containerId="dropdown-accounting-container"
      links={menuLinks}
    >
      <Title
        id="accounting-tab-1"
        className={condition1 ? 'active' : ''}
        onClick={(e) => handleMenu(e, routes.accounting.dashboard)}
      >
        {i18n.menu.view}
      </Title>
    </Dropdown>
  );
};

export default AccountingDropdown;
